
import React, { useState, useRef } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Tooltip,
    TextField,
    Snackbar,
    Alert,
    Popover
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import CallIcon from "@mui/icons-material/Call";
import EmailIcon from "@mui/icons-material/Email";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {useTheme} from '@mui/material/styles';
import {LayoutFieldModel} from '../../models/models';
import {validateEmailField} from '../../utils/fieldValidations';
import {checkLayoutFieldRequirement} from '../../utils/fieldValidations';

export const EmailFieldComponent: React.FC<{
  layoutField: LayoutFieldModel,
  value: string,
  onChange: (value: string, layoutField: LayoutFieldModel) => void,
}> = ( {
  layoutField,
  value,
  onChange
}) => {


  const styles = ContainerClasses();

  const searchFieldContainer = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  }

  const required = checkLayoutFieldRequirement(layoutField);

  const [error, setError] = useState(required && !value);
  const [openPopover, setOpenPopover] = useState(false);
  const anchorRef = useRef(null);

  const handleChange = (event: any) => {
    const value = event.target.value;

    //following regex prohibits double dots ..
    //and ensures valid email format
    const patternMatched = validateEmailField(value)
    setError(!patternMatched);

    onChange(value, layoutField)

  }

  const handleClick = () => {
    window.location.href = `mailto:${value}`;
  }

  const handleCopyClick = () => {
    const textToCopy = value ?? "";
    navigator.clipboard.writeText(textToCopy);
    setOpenPopover(true);
    setTimeout(() => setOpenPopover(false), 1500);
  }


  return (
    <>
      <TextField
         fullWidth
         error={error}
         disabled={layoutField.AccessSetting_sys === 'read'}
         multiline={false}
         rows={1}
         required={checkLayoutFieldRequirement(layoutField)}
         size="small"
         label={`${layoutField.ReferencedField_sys.Label_sys} (max. ${layoutField.ReferencedField_sys.Length_sys})`}
         variant="filled"
         value={value}
         onChange={(event) => handleChange(event)}
         helperText={layoutField.ReferencedField_sys.HelpText_sys}
         inputProps={{
           maxLength: layoutField.ReferencedField_sys.Length_sys,
         }}
         InputProps={{
           disableUnderline: true,
           startAdornment:(
              <InputAdornment position="start">
                  <IconButton ref={anchorRef} size="small" onClick={() => handleCopyClick()}>
                    <ContentCopyIcon fontSize="small"/>
                  </IconButton>
            </InputAdornment>
           ),
           endAdornment: (
              <InputAdornment position="end">
                <IconButton disabled={!validateEmailField(value)} size="small" onClick={() => handleClick()}>
                  <EmailIcon />
                </IconButton>
            </InputAdornment>
          )
         }}
      />

      <Popover
        open={openPopover}
        anchorEl={anchorRef.current}
        onClose={() => setOpenPopover(false)}
        anchorOrigin={{vertical: "top", horizontal: "center"}}
        transformOrigin={{ vertical: "top", horizontal: "left"}}
        PaperProps={{
          sx: {
            p: 2,
            borderRadius: 2
          }
        }}
      >
        <Typography variant="body2">
          Email copied
        </Typography>
      </Popover>
    </>
    );

};
